import { claimReferral } from "../services/userService";

export const PENDING_REFERRAL_STORAGE_KEY = "pendingReferral";

/**
 * If localStorage has a pending ?ref= code and the user has no referredBy yet,
 * POST /user/referral and return the updated user. Otherwise returns user unchanged.
 * Clears localStorage after success or on 400/409.
 */
export async function applyPendingReferralClaim(token, user) {
  if (!token || !user) return user;
  const pending = localStorage.getItem(PENDING_REFERRAL_STORAGE_KEY)?.trim();
  if (!pending || user.referredBy) return user;
  try {
    const updated = await claimReferral(token, pending);
    localStorage.removeItem(PENDING_REFERRAL_STORAGE_KEY);
    return updated;
  } catch (e) {
    const status = e?.response?.status;
    if (status === 409 || status === 400) {
      localStorage.removeItem(PENDING_REFERRAL_STORAGE_KEY);
    }
    return user;
  }
}
